module.exports = __webpack_public_path__ + "img/parable-of-the-sower.c5cf7343.png";